<template>
  <span
    class="rounded-full text-xs md:text-sm flex items-center"
    >
    {{ seniorityLabel.label }}</span
  >
</template>

<script setup lang="ts">
import { computed } from 'vue'
import experienceLevels from '@/const/experienceLevels'
const props = defineProps<{
  seniorityLevel: string
}>()

const seniorityLabel = computed(() => {
  const level = experienceLevels.find((level) => level.id === props.seniorityLevel)
  return level
    ? { label: level.label, color: level.color, textColor: level.textColor }
    : { label: 'No experience level specified', color: '#ffeab6', textColor: '#000' }
})
</script> 